/* Mobau Pro – Zuschnittware + Preiseinheit im Warenkorb absichern (Agent A, 11.10.2026).
   Ergänzt fehlende Line-Item-Properties „Zuschnitt“ und „Einheit“ (z. B. „m² (Menge = Quadratmeter)“).
   Jeder Warenkorb-Weg (Produktseite, Karten, Empfehlungen, Suche, Startseite, Alt-Vorlagen) soll die
   Line-Item-Property „Zuschnitt“ tragen, damit der Ausschluss von Rückgabe/Umtausch in Kasse, Bestellbestätigung
   und Bestellung steht. Wege, die die Eigenschaft (noch) nicht mitschicken, werden hier nachgezogen:
   Zeilen ohne „Zuschnitt“, deren Variante Zuschnitt ist (Vorlage product.mobau-zs: Metafeld mobau.zuschnitt, sonst
   Produkt-Tag „zuschnitt“), bekommen sie per /cart/change.js. */
(function () {
  if (window.__mobauZuschnitt) return;
  window.__mobauZuschnitt = true;
  var TEXT = 'auf Maß geschnitten – Rückgabe und Umtausch ausgeschlossen';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('mobau-zuschnitt-v3') || '{}'); } catch (e) {}
  function merke() { try { sessionStorage.setItem('mobau-zuschnitt-v3', JSON.stringify(cache)); } catch (e) {} }
  /* Kennzeichen je Variante aus der Vorlage product.mobau-zs: v = Zuschnitt, e = Preiseinheit („m² (Menge = Quadratmeter)“) */
  function infos(handle) {
    if (handle in cache) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '?view=mobau-zs', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '{}'; })
      .then(function (t) { try { return JSON.parse(t); } catch (e) { return {}; } })
      .then(function (d) { cache[handle] = { v: d.v || {}, e: d.e || {} }; merke(); return cache[handle]; })
      .catch(function () { return { v: {}, e: {} }; });
  }
  var laeuft = false;
  function pruefen() {
    if (laeuft || !window.fetch) return;
    laeuft = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        return Promise.all(items.map(function (it) {
          var p = it.properties || {};
          if (p.Zuschnitt && p.Einheit) return null;
          return infos(it.handle).then(function (d) {
            var neu = {};
            if (!p.Zuschnitt && d.v && d.v[String(it.variant_id)]) neu.Zuschnitt = TEXT;
            if (!p.Einheit && d.e && d.e[String(it.variant_id)]) neu.Einheit = d.e[String(it.variant_id)];
            return Object.keys(neu).length ? { it: it, neu: neu } : null;
          });
        }))
          .then(function (liste) {
            liste = liste.filter(Boolean);
            if (!liste.length) return null;
            /* nacheinander, weil sich die Zeilenschlüssel bei jeder Änderung neu bilden */
            return liste.reduce(function (kette, x) {
              return kette.then(function () {
                var it = x.it, props = {};
                Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
                Object.keys(x.neu).forEach(function (k) { props[k] = x.neu[k]; });
                return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
              });
            }, Promise.resolve()).then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); });
          });
      })
      .then(function (neu) {
        laeuft = false;
        if (!neu) return;
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        /* Mini-Warenkorb neu zeichnen, ohne ihn zu öffnen */
        document.querySelectorAll('.modern-cart-wrapper').forEach(function (w) { if (w._renderModernCart) w._renderModernCart(neu); });
      })
      .catch(function () { laeuft = false; });
  }
  document.addEventListener('cart:updated', function () { setTimeout(pruefen, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruefen); else pruefen();
})();
